import React, { useState, useEffect } from "react";
import Header from "../../layouts/Header";
import { useHistory, useParams } from "react-router-dom";
import AddEditWorkflow from "./AddEditWorkflow";
import { Col, Row } from "react-bootstrap";
import WorkflowDesigner from "./WorkflowDesigner";
import "../../assets/styles/local/WorkflowAutomation.css";
import {
  AddNewWorkflow,
  FetchWorkflowById,
  TriggerWorkflowById,
} from "../../redux/actions/workflowAutomationActions";
import { useDispatch, useSelector } from "react-redux";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const AddWorkflowAutomation = () => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Workflow-Automation-Add-Edit").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const [workflowCondition, setWorkflowCondition] = useState("Add new");
  const [showWorkflowDesigner, setShowworkflowDesignern] = useState(false);
  const [workflowAutomationForm, setWorkflowAutomationForm] = useState({});

  const [workflowActionLabel, setWorkflowActionLabel] = useState("Add");

  useEffect(() => {
    if (id) {
      setWorkflowActionLabel("Update");
      FetchWorkflowById(id)
        .then((res) => {
          let workflowRes = res.data;

          if (workflowRes && workflowRes.status) {
            if (workflowRes.data.length > 0) {
              let _workflowData = {
                ...workflowRes.data[0],
                moduleName: workflowRes.data[0].modulename,
                subModuleName: workflowRes.data[0].submodulename,
                formName: workflowRes.data[0].formname,
              };

              setWorkflowAutomationForm(_workflowData);
            }

            setShowworkflowDesignern(true);
          }

          setWorkflowCondition("Update");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [id]);

  const onWorkflowformSubmit = (formData) => {
    let payload = {
      workFlowName: formData.workflowName,
      moduleId: formData.moduleId,
      subModuleId: formData.subModuleId,
      formId: formData.formId,
      isTemplates: 0,
    };

    AddNewWorkflow(payload)
      .then((res) => {
        if (res.status && res.data && res.data.data) {
          let workflowData = {
            ...res.data.data,
            moduleName: formData.moduleName,
            subModuleName: formData.subModuleName,
            formName: formData.formName,
          };

          setWorkflowAutomationForm(workflowData);
          setShowworkflowDesignern(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const TriggerAutomation = () => {
    TriggerWorkflowById(id)
      .then((res) => {
        console.log(res);
        alert(res.data.message);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <>
      {/* Header Section for path display */}
      <Header
        leftComponent={
          <div className="products-and-parts-header-content">
            <div
              className="products-and-parts-main-title  cursor-pointer"
              onClick={() => {
                history.push("/settings");
              }}
            >
              {/* Settings */}
              {t("Settings")}
            </div>
            <p className="products-and-parts-sub-title">
              {/* Workflow Automation - {workflowCondition} */}
              {t("Workflow Automation - Add new").slice(0, 19)} -{" "}
              {workflowCondition}
            </p>
          </div>
        }
      />

      {/* Actions */}
      <div className="ps-4 pe-5">
        <Row>
          <Col xl={7} lg={8} md={6} sm={12}></Col>
          <Col xl={5} lg={4} md={6} sm={12} className="add-col-item ">
            <button
              className="workflow-action-btn cancel p-2"
              onClick={() => {
                history.push("/workflow-automation");
              }}
            >
              {/* Cancel */}
              {t("Cancel")}
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button
              className="workflow-action-btn add p-2"
              onClick={() => {
                history.push("/workflow-automation");
              }}
            >
              {workflowActionLabel}
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {workflowCondition === "Update" && (
              <button
                className="workflow-trigger-btn cancel p-2 d-none"
                onClick={TriggerAutomation}
              >
                {/* Trigger Automation */}
                {t("Trigger Automation")}
              </button>
            )}
          </Col>
        </Row>
      </div>

      <div className="p-5 pt-4">
        {!showWorkflowDesigner && (
          <AddEditWorkflow submit={onWorkflowformSubmit} />
        )}
        {showWorkflowDesigner && (
          <WorkflowDesigner formData={workflowAutomationForm} />
        )}
      </div>
    </>
  );
};

export default AddWorkflowAutomation;
